// extracted by mini-css-extract-plugin
export default {"Backdrop":"pageModal_Backdrop__cQ7xS","Modal":"pageModal_Modal__pFOH+","FullScreen":"pageModal_FullScreen__TichP","Container":"pageModal_Container__UBw-I"};